export default __webpack_public_path__ + "static/media/collectible-final-unique-bf.3d8eadf9.jpg";